<template>
	<div v-if="!is_logged_in">
		<div class="not_logged_in" v-if="!is_logged_in">
			<a class="btn_head" :href="$router.resolve({ name: 'auth-login' }).href">
				{{ $t('new_ui.components.header_component.auth.login') }}
			</a>
			<a
				:href="$router.resolve({ name: 'auth-register' }).href"
				class="btn_head back_on"
			>
				{{ $t('new_ui.components.header_component.auth.signup') }}
			</a>
		</div>

		<div class="logged_in" v-if="is_logged_in"></div>
	</div>
</template>

<script>
export default {
	el: '#menu_auth',
	name: 'menu-auth',
	props: {
		is_logged_in: Boolean,
	},
	data: function () {
		return {
			show1: false,
			show2: false,
		};
	},
	methods: {},
};
</script>
